import { TYPES } from "@/view/ProseMirrorNode/ProseMirrorNode.constants";
import rawTextNodeIsInvalid from "@/view/utils/rawTextNodeIsInvalid";

/**
 * Updating rawText, which represents the prose mirror tree, to remove nodes of specific types
 * that are not relevant to rendering the content and cause issues with content-based
 * features such as annotations, paragraph count, and read aloud highlighting.
 *
 * These node types include:
 * - Ignore blocks, which are used to ensure a block isn't counted when calculating lexile level.
 * - Power words and key terms when removePowerWords is true
 */

const sanitizeRawText = (rawText, removePowerWords) => {
  // Power words are not at the top level of the text,
  // so the function must be called recursively to traverse the full tree.
  const blockTypesToRemove = [
    TYPES.ignoreBlock,
    ...(removePowerWords ? [TYPES.powerWord, TYPES.keyTerm] : []),
  ];

  if (!rawText?.content) return rawText;

  const newContentChild = rawText?.content?.reduce(
    (sanitizedContent, currentNode) => {
      const updatedNode = currentNode?.content
        ? sanitizeRawText(currentNode, removePowerWords)
        : currentNode;

      if (rawTextNodeIsInvalid(updatedNode)) {
        return [...sanitizedContent];
      } else if (blockTypesToRemove.includes(updatedNode.type)) {
        return [...sanitizedContent, ...updatedNode?.content];
      }

      return [...sanitizedContent, updatedNode];
    },
    [],
  );

  return { ...rawText, content: newContentChild };
};

export default sanitizeRawText;
